import React from 'react'
import {connect} from 'react-redux'
import {selectUserInfo} from '../../../../redux/modules/session'
import EditProfile from '../components/EditProfile'
import {Switch, Route} from 'react-router'
import RedirectWithParams from '../../../../core/components/redirect-with-params/RedirectWithParams'
import VisibleAccountSettings from './VisibleAccountSettings'
import NotificationSettings from '../components/NotificationsSettings'
import VisibleChangePassword from './VisibleChangePassword'

class VisibleEditProfile extends React.PureComponent {
  mobileBreakPoint = 825;
  constructor(props) {
    super(props)
    this.state = {
      isMobile: false
    }

    this.resize = this.resize.bind(this)
  }
  componentDidMount() {
    document.title = 'Edit Profile - Expii'
    const {sessionUserId, match, history} = this.props
    if (sessionUserId !== parseInt(match.params.userId)) {
      history.push(`/user/${sessionUserId}/edit`)
    }
    window.addEventListener('resize', this.resize, false)
    this.resize()
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resize, false)
  }
  resize() {
    const w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      x = w.innerWidth || e.clientWidth || g.clientWidth
      //y = w.innerHeight|| e.clientHeight|| g.clientHeight

    this.setState({
      isMobile: x <= this.mobileBreakPoint
    })
  }
  render() {
    const {isLoggedIn, location, match} = this.props
    const {isMobile} = this.state

    if (!isLoggedIn) {
      return <RedirectWithParams to="/login" />
    }

    return (
      <EditProfile location={location} match={match}>
        {
          isMobile
            ? <div>
              <Route exact path="/user/:userId/edit/account"
                component={VisibleAccountSettings} />
              <Route exact path="/user/:userId/edit/account"
                component={VisibleChangePassword} />
              <Route exact path="/user/:userId/edit/account"
                component={NotificationSettings} />
              <RedirectWithParams from='/user/:userId/edit' exact to="/user/:userId/edit/account" />
            </div>
            : <Switch>
              <Route exact path="/user/:userId/edit/account"
                component={VisibleAccountSettings} />
              <Route exact path="/user/:userId/edit/password"
                component={VisibleChangePassword} />
              <Route exact path="/user/:userId/edit/notifications"
                component={NotificationSettings} />
              <RedirectWithParams from='/user/:userId/edit' exact to="/user/:userId/edit/account" />
            </Switch>
        }
      </EditProfile>
    )
  }
}

const mapStateToProps = state => {
  const userInfo = selectUserInfo(state)
  return {
    isLoggedIn: userInfo.isLoggedIn,
    sessionUserId: parseInt(state.getIn(['session','user','id']))
  }
}

export default connect(
  mapStateToProps
)(VisibleEditProfile)



// WEBPACK FOOTER //
// ./src/domains/user/edit-profile/containers/VisibleEditProfile.js